'use strict';

var _ = require('lodash');

module.exports = FilterDirective;

function FilterDirective($filter) {

  function link($scope, el) {
    var treeFilter = $filter('sbTreeFilter');
    var containerEl = el.children().eq(0);
    var inputEl = containerEl.children().eq(0);

    if ($scope.list && $scope.lists) {
      throw new Error('attrs `list` and `lists` are mutually exclusive');
    }

    var onSearchTermChange = _.debounce(function (newSearch) {
      $scope.$evalAsync(function () {
        if ($scope.list) {
          $scope.filtered = treeFilter($scope.list, newSearch, $scope.keys, $scope.maxDepth);
        }
        // filter multiple lists using the same term
        else if ($scope.lists) {
            $scope.filtered = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = $scope.lists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var list = _step.value;

                $scope.filtered.push(treeFilter(list, newSearch, $scope.keys, $scope.maxDepth));
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                  _iterator['return']();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
      });
    }, 250);

    var onSourceListChange = function(newSourceList) {

      $scope.list = newSourceList;
      onSearchTermChange($scope.searchTerm);
    };

    function onFocus() {
      containerEl.addClass('focused');
    }

    function onBlur() {
      containerEl.removeClass('focused');
    }

    inputEl.on('focus', onFocus);
    inputEl.on('blur', onBlur);
    $scope.$watch('searchTerm', onSearchTermChange);
    $scope.$watch('list', onSourceListChange);
  }

  return {
    link: link,
    restrict: 'AE',
    scope: {
      filtered: '=?', // the filtered list
      keys: '@', // keys to search
      list: '=?', // mutually exclusive of `lists`
      lists: '=*?', // mutually exclusive of `list`
      placeholder: '@',
      searchTerm: '=?', // current search term
      maxDepth: '@maxDepth'
    },
    templateUrl: 'saturn/filter/search/search.tpl.html'
  };
}



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/filter/es5/search/SearchDirective.js